import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Tab from '../../component/Inc/Tab';
function PopManageEmployee(props) {
  const {open, close} = props;
  const [modalAlert, setModalAlert] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const listItems = ['디자인/IT', '전략기획실', '전략기획실', '교무부', '교무부', '교무부', '교무부'];
  const listItems2 = ['디자인/IT', '마케팅', '마케팅', '디자인/IT', '디자인/IT', '디자인/IT', '디자인/IT'];

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedTeamItem, setSelectedTeamItem] = useState(null);
  const tab = [
    {title: '부서 등록', value: 0},
    {title: '팀 등록', value: 1},
    {title: '담당 등록', value: 2},
    {title: '담당2 등록', value: 3}
  ];
  return (
    <Modal open={open} close={close} type="com_input com_manage_company pop_manage_department">
      <h2 className="pop_tit">부서관리</h2>
      <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="full" />
      {tabIdx === 0 && (
        <>
          <div className="content_container scroll">
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems.map((item, index) => (
                  <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_input_wrap">
              <input type="text" className="input" defaultValue={`출판사업부`} />
            </div>
            <div className="com_blue_txt"> 해당 부서에 인원이 없어야 삭제 가능합니다.</div>
          </div>
          <div className="btn_container center">
            <button onClick={() => setModalAlert(true)} className="com_btn gray xs">
              삭제
            </button>
            <button className="com_btn orange xs">저장</button>
            {/*<button className="com_btn orange xs">등록</button>*/}
          </div>
        </>
      )}
      {tabIdx === 1 && (
        <>
          <div className="content_container scroll">
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems.map((item, index) => (
                  <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems2.map((item, index) => (
                  <li key={index} className={`item ${selectedTeamItem === index ? 'selected' : ''}`} onClick={() => setSelectedTeamItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_input_wrap">
              <input type="text" className="input" defaultValue={`온라인컨텐츠팀`} />
            </div>
          </div>
          <div className="btn_container center">
            <button className="com_btn orange xs">등록</button>
          </div>
        </>
      )}

      {tabIdx === 2 && (
        <>
          <div className="content_container scroll">
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems.map((item, index) => (
                  <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems2.map((item, index) => (
                  <li key={index} className={`item ${selectedTeamItem === index ? 'selected' : ''}`} onClick={() => setSelectedTeamItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_input_wrap">
              <input type="text" className="input" defaultValue={`온라인컨텐츠팀`} />
            </div>
          </div>
          <div className="btn_container center">
            <button className="com_btn orange xs">등록</button>
          </div>
        </>
      )}

      {tabIdx === 3 && (
        <>
          <div className="content_container scroll">
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems.map((item, index) => (
                  <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick mb_no">
                {listItems2.map((item, index) => (
                  <li key={index} className={`item ${selectedTeamItem === index ? 'selected' : ''}`} onClick={() => setSelectedTeamItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
              <button className="com_btn gray xs ">+추가</button>
            </div>
            <div className="com_input_wrap">
              <input type="text" className="input" defaultValue={`온라인컨텐츠팀`} />
            </div>
          </div>
          <div className="btn_container center">
            <button className="com_btn orange xs">등록</button>
          </div>
        </>
      )}

      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt">
            삭제시 복구가 불가능 합니다. <br />
            삭제 하시겠습니까?
          </div>
          <div className="btn_container">
            <button className="com_btn gray xs" onClick={() => setModalAlert(false)}>
              취소
            </button>
            <button className="com_btn orange xs">삭제</button>
          </div>
        </div>
      </Modal>
    </Modal>
  );
}

export default PopManageEmployee;
